export const  getParamsOfGrid  = (className, dimensions, height) => {
    const SIZE_OF_CELL = 20;
    /**
     * className  = class of searching element -> type : string
     * dimensions = elements dimension -> type : object
     * height = real height of element -> type : number
     */
    /*** DEFAULT SIZE OF CELL IS 20sm ***/
        const elements = document.body.getElementsByClassName(className);

        /*** if element with this class don't exist ***/
        if(!elements){ return false}
        /*** one sizeOfCell for all elements ***/
        const numberOfCellsReal = dimensions[elements[0].dataset.areaDimension]/SIZE_OF_CELL;
        const oneSizeOfCell = (elements[0].clientWidth)/ numberOfCellsReal;
        const elementOptions = {};
        /*** create elements options ***/
        for(let i = 0; i < elements.length; i++){
            const numberOfCellsWidth = dimensions[elements[i].dataset.areaDimension]/SIZE_OF_CELL,
                  numberOfCellsHeight = height/SIZE_OF_CELL;
                  // sizeOfCell = elements[i].clientWidth /numberOfCellsWidth;

            elementOptions[elements[i].dataset.areaName] = {
                areaName : elements[i].dataset.areaName,
                sizeOfCell : oneSizeOfCell,
                numberOfCellsWidth : numberOfCellsWidth,
                numberOfCellsHeight : numberOfCellsHeight,
                areaHeight : elements[i].clientWidth
            };
        }

    return {...elementOptions};
};


// WEBPACK FOOTER //
// ./src/helpers/getParamsOfGrid.js